import { render } from "./TransmutedGradeDialog.vue?vue&type=template&id=12252677"
import script from "./TransmutedGradeDialog.vue?vue&type=script&lang=js"
export * from "./TransmutedGradeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__